import { render } from "./SafetyHealth.vue?vue&type=template&id=333686c6&ts=true"
import script from "./SafetyHealth.vue?vue&type=script&lang=ts"
export * from "./SafetyHealth.vue?vue&type=script&lang=ts"

import "./SafetyHealth.vue?vue&type=style&index=0&id=333686c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__